import sheetdb from 'sheetdb-node';
import Loading from '../loading';
import './instruct.css'
import { useState } from 'react';
import { Button, Col, Row, Container, Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, Form, FormGroup, Input, Label } from 'reactstrap';
import me from './menobg.png'
const Instructor = ()=>{

  var config = {
    address: 'lmrht3p7ssu0r',
  };
  
  // Create new client
  var client = sheetdb(config);
  
  const [successDiag, setSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [parentName, setParentName] = useState("")
  const [studentName, setStudentName] = useState("")
  const [number, setNumber] = useState("")
  const [email, setEmail] = useState("")
  

  const handleChange = (event) => {
    if(event.target.name == "parentName"){
      setParentName(event.target.value)
    }
    if(event.target.name == "email"){
      setEmail(event.target.value)
    }
    if(event.target.name == "parentPhone"){
      setNumber(event.target.value)
    }
    if(event.target.name == "studentName"){
      setStudentName(event.target.value)
    }
  }

  const handleSubmit = () => {
    try{
      setLoading(true)
      client.create({ 
        ParentName: parentName, 
        TeenName: studentName,
        TeenAge: 10,
        ParentEmail: email,
        ParentPhone: number
      }, "Students").then(()=>{
      toggle();
      setLoading(false)
      setSuccessDialog(true)
      })
    }
    catch(ex){
      setLoading(false)
      alert(ex.data)
    }
  }


    const [formToggle, setFormToggle] = useState(false)
    const toggle = () => setFormToggle(!formToggle);
    return(<>
    {loading == true ? <Loading/> : <span></span>}
    <Modal style={{border:'none'}}  isOpen={successDiag} toggle={()=>{setSuccessDialog(false)}}>
        <ModalHeader className='text-center' style={{border:'none'}} toggle={()=>{setSuccessDialog(false)}}><h3 className='text-success'>Congratulations!</h3></ModalHeader>
        <ModalBody>
        <Container>
          <Row>
            <Col sm={12} lg={12} md={12}>

            </Col>
            <Col className='text-center mb-5' lg={12} md={12} sm={12}>
              Thanks for signing up! I will be reaching out through text shortly. Talk soon :)
            </Col>
          </Row>
        </Container>
        </ModalBody>
      </Modal>





             <Modal style={{border:'none'}}  isOpen={formToggle} toggle={toggle}>
        <ModalHeader style={{border:'none'}} toggle={toggle}>One Step Closer to a Productive Summer</ModalHeader>
        <ModalBody>
        <Form>
  <Row>
  <Col md={12}>
      <FormGroup>
        <Label for="parentName">
          Parent Name
        </Label>
        <Input
          onChange={handleChange}
          id="parentName"
          name="parentName"
          placeholder="Name of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="studentName">
        Student Name
        </Label>
        <Input
        onChange={handleChange}
          id="studentName"
          name="studentName"
          placeholder="Name of Student"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="email">
          Parent Email
        </Label>
        <Input
        onChange={handleChange}
          id="email"
          name="email"
          placeholder="Email of Parent"
          type="email"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="parentPhone">
        Parent Phone
        </Label>
        <Input
        onChange={handleChange}
          id="parentPhone"
          name="parentPhone"
          placeholder="Phone number of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
  </Row>
  
  
  <Row>
    <Col md={6}>
      
    </Col>
    <Col md={4}>
      
    </Col>
    <Col md={2}>
      
    </Col>
  </Row>
</Form>
        </ModalBody>
        <ModalFooter style={{border:'none'}} >
          <Button color="primary" onClick={handleSubmit}>
            Sign Up
          </Button>
        </ModalFooter>
      </Modal>


      <Container>
        <Row className='text-center mb-2 mt-5'>
                <h1 className='text-primary' id='curriculum' style={{fontWeight:'bolder'}}>Meet your instructor!</h1>
            </Row>
        </Container>
    
    <section  style={{borderRadius:'20px', backgroundColor:'#242f83'}}>
        
    <Container>
    
            <Col lg={{size:'10', offset:'1'}} md={{size:'10', offset:'1'}} sm={12}>
            <Row>
            <Col className='mt-5' lg={3} md={3} sm={12}>
                    <div style={{overflow:'hidden', maxHeight:'300px', borderRadius:'50%'}}>
                        <img className='smallImage' src={me} width={'100%'} />
                    </div>
                </Col>
                <Col className='text-white mt-5 mb-5' lg={9} md={9} sm={12}>
                    <h3>Hi There!</h3>
                    <h2>I am Sarim</h2>
                    <h4>Software Engineer - Computer Engineer - Web Designer</h4>
                    <p style={{fontSize:'14px'}}>With a Bachelors in Computer Science and a certification in Computer Engineering, I am extremely passionate about teaching your kids how to build their own PC.
                        I still remember how growing up I didn't really have the high budget of building a gaming PC like my friends did, but I did want to play all those games with them. 
                        Not wanting to feel left out, I took it up as a challenge to build myself the best possible gaming PC under $150. Knowing how expensive new parts would be, I focused on 
                        older parts and learned along the way. I was 14 when I built my first gaming PC all on my own and the sense of achievement I got from that is uncomparible to any feeling 
                        up to this day. Ever since then, I never looked back. I want other kids to have the same feeling I did back then. With years of trial and error, a whole lot of knowlege and 
                        access to getting computer parts for cheap, I would love the chance of teaching your kids how to build their very own Gaming PC. 
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-center mb-5' md={12}>
                <Button style={{fontWeight:'bold'}} onClick={toggle} color="warning">Enroll Now</Button>
                </Col>
            </Row>
            </Col>
            
        </Container>
    </section>
        

    </>)
}

export default Instructor;